import { _t, isTablet } from '../base'

export function newsletter() {
    const newsletter = $('.custom-footer__newsletter')
    const header = newsletter.find('.newsletter-header h3');

    newsletter.addClass('container').insertBefore('#footer')
    newsletter.find('.topic span').text(_t('newsletter.title'))
    newsletter.find('input').attr('placeholder', _t('newsletter.placeholder'))
    newsletter.contents().wrapAll($('<div class="newsletter-wrapper"></div>'))
    newsletter.find('.btn').text(_t('newsletter.btn'))

    if (isTablet()) return

    $('<span>' + _t('newsletter.subtitle') + '</span>').insertAfter(header)
    newsletter.find('.btn').insertAfter(newsletter.find('input.form-control'))
}
